import $ from "jquery";
import * as GC from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./callBackFunctions";

export default function standart() {}

export const rowsHandleDelete = () => {
  // 1. bu kayıtın relationlarını getir.
  // 2. tüm relationlarını sil.
  // 3. sonra kayıtı sil.
  $("#cover-spin").show(0);
  var BreakException = {};
  window.$catalog_management_units_selectedIds.forEach(async (element) => {
    try {
      let getRowOfDetail = await omnimap.GetActionsOfRowAction(
        element,
        window.$catalog_management_units_token
      );

      // if (getRowOfDetail.data.delete_allowed) {
      //   throw BreakException;
      // }

      let realtions = await omnimap.GetRelationAction(
        element,
        1,
        30,
        window.$catalog_management_units_token
      );

      /**
       * * 1. silinmek istenen kayıtın beheerobject ilişkisi varsa sinemez olması gerekmektedir
       */

      if (realtions.data !== undefined) {
        await realtions.data.forEach(async (relation) => {
          let result = await omnimap
            .DeleteRelationAction(
              relation.identification,
              window.$catalog_management_units_token
            )
            .catch((error) => {
              console.log(error);
            });
          var test = "";
        });
      }

      GC.sleep(2000).then(async () => {
        let result = await omnimap
          .Delete(element, window.$catalog_management_units_token)
          .catch((error) => {
            console.log(error);
          });

        CallBackFunctions.RowsDeletedCallBack(
          window.$catalog_management_units_token
        );
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    }
  });
};

export function GetColumnProperties(callType) {
  omnimap
    .GetColumnPropertiesAction(window.$catalog_management_units_token)
    .then((result) => {
      CallBackFunctions.GetColumnPropertiesCallBack(result, callType);
      // fillDetail();
    });
}